interface LogoProps {
  className?: string;
  loading?: 'lazy' | 'eager';
}

export function Logo({ className = 'h-8 w-auto', loading }: LogoProps) {
  return (
    <img
      src="/logo.svg"
      alt="Plevits"
      className={className}
      loading={loading}
    />
  );
}
